export enum PlayingTypesEnum {
  UNTIL_ORDER_ACCEPTED = 0,
  ONLY_ONCE = 1,
  NO_SOUND = 2,
}
